import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userData: null,
  accessToken: null,
  profile: null
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.userData = action.payload.userData;
      state.accessToken = action.payload.accessToken;
    },
    setProfile: (state, action) => {
      state.profile = action.payload;
    },
    clearUser: (state) => {
      state.userData = null;
      state.accessToken = null;
      state.profile = null;
    }
  }
});

export const { setUser, setProfile, clearUser } = userSlice.actions;
export default userSlice.reducer;
